import React, { useState, useEffect } from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

const RunToggleButton = (props) => {
  const [dryRun, setDryRun] = useState(props.dryRun);
  
  useEffect(() => {
    setDryRun(props.dryRun);
  }, [props.dryRun])

  useEffect(() => {
    props.update(dryRun);
  }, [dryRun]);

  return (
    <div>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip className="discovery-tooltip"><div className="p-2">Running a Discovery with "Dry Run" enabled will save the sample strategy without running an analysis. This will enable users to see what the Discovery will look at without running the analysis. ( Upcoming Feature )</div></Tooltip>}
      >
        <span>
          <Form.Check 
            disabled
            checked={dryRun === true}
            type="radio"
            inline 
            label="Dry Run" 
            name="dry-run" 
            value="true"
          />
        </span>
      </OverlayTrigger>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip className="discovery-tooltip"><div className="p-2">Live Run ( Default ) will tell the system to use these sample parameters to run an analysis on the data source.</div></Tooltip>}
      >
        <span>
          <Form.Check
            checked={dryRun === false}
            type="radio" 
            inline 
            label="Live Run" 
            name="dry-run" 
            value="false"
            onChange={(e) => {
              setDryRun(e.target.value === 'true')
            }}
          />
        </span>
      </OverlayTrigger>
    </div>
  );
}

export default RunToggleButton
